<p>refresh-reports works!</p>
